import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function SalaryReceiptsIcon({ className }: IconProps) {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_3937)">
        <path
          d="M61.7523 70V3.17221C61.7523 1.48036 60.2719 0 58.5801 0H3.17221C1.48036 0 0 1.48036 0 3.17221V61.3293C0 65.9819 3.80665 69.7885 8.45922 69.7885H61.7523V70Z"
          fill="#EAEEF9"
        />
        <path
          d="M46.1028 63.8671H27.281C26.8581 63.8671 26.2236 63.4441 26.2236 62.8097C26.2236 62.1752 26.6466 61.9637 27.281 61.9637H46.1028C46.5257 61.9637 47.1602 62.3867 47.1602 62.8097C47.1602 63.2326 46.5257 63.8671 46.1028 63.8671Z"
          fill="#B0B9CF"
        />
        <path
          d="M22.4173 63.8671H20.3025C19.8796 63.8671 19.2451 63.4441 19.2451 62.8097C19.2451 62.1752 19.6681 61.9637 20.3025 61.9637H22.4173C22.8403 61.9637 23.2632 62.3867 23.2632 62.8097C23.2632 63.2326 23.0518 63.8671 22.4173 63.8671Z"
          fill="#B0B9CF"
        />
        <path
          d="M8.6709 70C12.689 70 16.0727 67.0393 16.7072 63.0211C16.7072 62.3867 17.3416 61.9637 17.976 61.9637H68.5198C69.3658 61.9637 70.0002 62.5982 69.7887 63.4441C69.1543 67.2508 65.7706 70 61.7525 70H8.6709Z"
          fill="#00C4B3"
        />
        <path
          d="M49.0637 22.2054C48.8522 22.2054 48.6407 22.2054 48.6407 21.994C48.2177 21.7825 48.0062 21.148 48.2177 20.7251C48.4292 20.5136 50.967 15.861 56.6769 16.707C57.0999 16.707 57.5229 17.3414 57.5229 17.7644C57.5229 18.1873 56.8884 18.6103 56.4655 18.6103C52.2359 17.9758 50.1211 21.571 49.9096 21.571C49.6981 21.994 49.4866 22.2054 49.0637 22.2054Z"
          fill="#FBFCFE"
        />
        <path
          d="M32.7796 10.3625C29.6074 10.3625 27.4925 10.997 26.6466 11.4199C26.2237 11.6314 26.0122 11.4199 25.8007 10.997C23.2629 6.34441 19.2448 4.65257 17.3415 4.01813C16.9185 3.80664 16.4956 4.01813 16.4956 4.65257C16.2841 6.76737 15.8611 12.4773 17.553 15.2266C17.553 15.6495 17.553 15.861 17.3415 16.0725C14.1693 18.8218 11.843 22.4169 11.2086 26.6465C11.2086 26.6465 9.7282 28.9728 5.92155 29.3958C5.49859 29.3958 5.28711 29.8187 5.28711 30.0302V37.2205C5.28711 37.6435 5.49859 37.855 5.92155 37.855C7.82487 38.0665 12.9004 38.7009 15.2267 40.8157C16.2841 42.0846 17.3415 43.142 18.8219 43.9879C18.8219 43.9879 21.1481 48.852 19.8793 53.9275C19.8793 54.3505 20.0907 54.7734 20.5137 54.7734H27.4925C27.9155 54.7734 28.3385 54.3505 28.127 53.9275C27.9155 52.6586 27.704 50.1208 28.55 47.5831C28.55 47.5831 32.991 49.2749 37.0092 47.1601C37.8551 50.1208 37.4321 52.6586 37.0092 53.716C36.7977 54.139 37.2206 54.5619 37.6436 54.5619H44.6225C45.0454 54.5619 45.2569 54.3505 45.2569 53.9275C45.4684 42.2961 52.0243 41.0272 52.0243 29.3958C52.6587 19.2447 44.8339 10.3625 32.7796 10.3625Z"
          fill="#FBFCFE"
        />
        <path
          d="M21.7828 23.2628C21.7828 24.9547 20.5139 26.2236 18.8221 26.2236C17.1302 26.2236 15.8613 24.9547 15.8613 23.2628C15.8613 21.571 17.1302 20.3021 18.8221 20.3021C20.5139 20.3021 21.7828 21.571 21.7828 23.2628Z"
          fill="#00C4B3"
        />
        <path
          d="M22.8398 30.0302C22.8398 35.5287 27.2809 39.9698 32.7794 39.9698C38.2779 39.9698 42.719 35.5287 42.719 30.0302C42.719 24.5317 38.2779 20.0906 32.7794 20.0906C27.4924 19.8792 22.8398 24.5317 22.8398 30.0302Z"
          fill="#00416B"
        />
        <path
          d="M36.7972 32.3565L38.912 33.4139C37.8546 35.1057 36.1628 36.3746 33.8365 36.3746C30.8758 36.3746 28.761 34.6828 28.1265 32.145H26.0117L27.0691 30.4532H27.915C27.915 30.2417 27.915 30.2417 27.915 30.0302C27.915 29.8187 27.915 29.8187 27.915 29.8187H26.0117L27.0691 28.1269H28.1265C28.761 25.5891 31.0872 23.6858 33.8365 23.6858C36.1628 23.6858 38.0661 24.7432 38.912 26.6465L36.7972 27.7039C36.1628 26.6465 35.1054 26.0121 33.8365 26.0121C32.3561 26.0121 31.0872 26.858 30.6643 27.9154H36.5857L35.3169 29.6072H30.0298V29.8187C30.0298 29.8187 30.0298 30.0302 30.0298 30.2417H35.1054L34.2595 31.9335H30.4528C31.0872 33.2024 32.1446 33.8369 33.625 33.8369C35.1054 33.8369 36.1628 33.2024 36.7972 32.3565Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_3937">
          <rect width="69.7885" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
